import Typography from '@mui/material/Typography';
import { TableTooltip } from 'common/components/Tooltip/TableTooltip';
import { styled } from '@mui/material/styles';
import { StickyCopyExtension } from 'src/common/StickyCopyExtension/StickyCopyExtension';
import {
  CellLayoutPrimaryTypography,
  CellLayout,
  CellLayoutRow,
  CellLayoutPrimaryLinkTypography,
  CellLayoutSecondaryTypography,
} from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { useLocation } from 'react-router';

export const TypographyStyled = styled(Typography)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}) as typeof Typography;

export const IccidImsiCell = ({ value, subValue, to }: any) => {
  const { pathname, search } = useLocation();
  return (
    <CellLayout>
      {value ? (
        <CellLayoutRow>
          <TableTooltip value={value}>
            <StickyCopyExtension value={value}>
              <CellLayoutPrimaryLinkTypography
                to={to}
                state={{ previousPath: `${pathname}${search}` }}
              >
                {value}
              </CellLayoutPrimaryLinkTypography>
            </StickyCopyExtension>
          </TableTooltip>
        </CellLayoutRow>
      ) : (
        <CellLayoutPrimaryTypography data-testid="primaryText">-</CellLayoutPrimaryTypography>
      )}
      {subValue !== undefined && (
        <CellLayoutRow>
          <TableTooltip value={subValue}>
            <StickyCopyExtension value={subValue}>
              <CellLayoutSecondaryTypography>{subValue || '-'}</CellLayoutSecondaryTypography>
            </StickyCopyExtension>
          </TableTooltip>
        </CellLayoutRow>
      )}
    </CellLayout>
  );
};
